import React from "react";
import { authRoles } from "../../auth/authRoles";

const ViewRecievedApplicationSingleRoutes = [

  {
    path: "/view_received_application_single",
    component: React.lazy(() => import("./AllViewRecievedApplicationSingle")),
    auth: authRoles.dashboard
  },
  
];

export default ViewRecievedApplicationSingleRoutes;
